<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <fiscal-years-select
            :fiscalYears="settings.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />

        <!-- RADIO DISPLAY AMOUNT -->
        <el-form-item
            :label="
                $t.__(
                    'dashboard.forms.PurInvoiceSettingForm.select_display_total_invoice_amount_or_total_outstanding_amount',
                )
            "
            class="mb-4"
            prop="displayAmount"
        >
            <el-radio-group v-model="form.displayAmount">
                <div class="mt-2">
                    <el-radio label="total">{{ $l10n.__('Total de la facture') }}</el-radio>
                </div>
                <div>
                    <el-radio label="due" class="mt-3">{{
                        $l10n.__('Total restant dû (TTC)')
                    }}</el-radio>
                </div>
            </el-radio-group>
        </el-form-item>
        <!-- RADIO TAX MODE -->
        <template v-if="form.displayAmount == 'total'">
            <el-form-item
                :label="$t.__('common.actions.select_tax_display')"
                class="mb-4"
                prop="taxMode"
            >
                <el-radio-group v-model="form.taxMode">
                    <div class="mt-2">
                        <el-radio label="exc">{{ $l10n.__('HT') }}</el-radio>
                    </div>
                    <div>
                        <el-radio label="inc" class="mt-3">{{ $l10n.__('TTC') }}</el-radio>
                    </div>
                </el-radio-group>
            </el-form-item>
        </template>
        <!-- SUBMIT -->
        <div class="aright mt-5">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="close"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                @click="submitForm"
            />
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    mixins: [SettingsFormMixin],
    data() {
        return {
            invoiceRules: {
                displayAmount: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
                taxMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
    mounted() {
        this.$emit('set-rules', this.invoiceRules);
    },
    components: {
        'fiscal-years-select': FiscalYearsSelect,
    },
};
</script>
